import { post } from './http';

export const add = async ({ articleNumber, quantity = 1, articleType = "", productName = "" }) => {
    if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
        throw 'Invalid quantity';
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    const response = await post('/api/cart/add', {
        articleNumber,
        quantity: parseFloat(quantity),
        CustomizedProductId: params.customizedProductId,
        AdditionalData: params.additional_data,
        Ids: params.ids,
        ArticleType: articleType,
        ProductName: productName
    });
    return response.json();
};

export const restart = async () => {    
    await post('/api/cart/restart');
};

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
};
